import { render, staticRenderFns } from "./TheMain.vue?vue&type=template&id=141530ee&scoped=true&"
import script from "./TheMain.vue?vue&type=script&lang=js&"
export * from "./TheMain.vue?vue&type=script&lang=js&"
import style0 from "./TheMain.vue?vue&type=style&index=0&id=141530ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141530ee",
  null
  
)

export default component.exports